/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import { AvatarName, Question, SelectLang, ThemeToggle } from '@zhiyue/core';

import AvatarDropdown from './AvatarDropdown';
import Footer from './Footer';
import NotificationIcon from './NotificationIcon';
import {
  DepartmentMemberMultiPickerField,
  DepartmentMemberPickerField,
  DepartmentMultiPickerField,
  DepartmentPickerField,
  MemberMultiPickerField,
  MemberPickerField,
} from './OrgPicker';
import { PersonnelDirectoryPicker } from './PersonnelDirectoryPicker';
import {
  PersonnelMemberMultiSelect,
  PersonnelMemberSelect,
} from './PersonnelMemberSelect';

export {
  AvatarDropdown,
  AvatarName,
  DepartmentMemberMultiPickerField,
  DepartmentMemberPickerField,
  DepartmentMultiPickerField,
  DepartmentPickerField,
  Footer,
  MemberMultiPickerField,
  MemberPickerField,
  NotificationIcon,
  PersonnelDirectoryPicker,
  PersonnelMemberMultiSelect,
  PersonnelMemberSelect,
  Question,
  SelectLang,
  ThemeToggle,
};

